/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldKorean = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M184 374V165h949q-21 222-90 414T863 937t-264 305-339 254L73 1322q144-79 269-175t225-214 173-256 110-303H184zm1439 380h297v210h-297v951h-250V0h250v754z"
    }));
export default SvgBoldKorean;
